export default __webpack_public_path__ + "a0297787a1a192213b5311506a6f0eb7.ttf";